import { format } from "date-fns";
import { FC } from "preact/compat";
import { getChats } from "~/core/store";
import { ChatListProps } from "./interfaces";

const ChatList: FC<ChatListProps> = ({ onSelect }) => {
    const { chats } = getChats();

    return (
        <div className="h-full max-h-[360px] overflow-y-overlay">
            {chats.value.map((chat) => (
                <button
                    key={chat.id}
                    type="button"
                    onClick={() => onSelect(chat.id)}
                    className="flex w-full px-4 py-2 border-b border-gray-200 last:border-b-0 hover:bg-sky-50 hover:border-sky-100 hover:text-sky-500 last:rounded-b-lg"
                >
                    <div className="w-[36px] h-[36px] min-w-[36px] rounded-full mr-4 bg-gray-200">
                        <span />
                    </div>
                    <div className="flex flex-col w-full">
                        <div className="flex items-center justify-between">
                            <div className="text-sm font-bold">{chat.name}</div>
                            <div className="text-xs font-bold text-gray-500">
                                {chat.lastMessage &&
                                    format(
                                        new Date(chat.lastMessage?.timestamp),
                                        "dd MMM HH:mm"
                                    )}
                            </div>
                        </div>
                        <div className="text-xs text-left text-gray-500 max-lines-1">
                            {chat.lastMessage && (
                                <>
                                    <span className="font-bold">
                                        {chat.lastMessage.sender.firstName}:{" "}
                                    </span>
                                    <span>{chat.lastMessage?.content}</span>
                                </>
                            )}
                        </div>
                    </div>
                </button>
            ))}
        </div>
    );
};

export default ChatList;
